import { render, staticRenderFns } from "./TermsConditionsView.vue?vue&type=template&id=d1e68abc&"
import script from "./TermsConditionsView.vue?vue&type=script&lang=ts&"
export * from "./TermsConditionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1e68abc')) {
      api.createRecord('d1e68abc', component.options)
    } else {
      api.reload('d1e68abc', component.options)
    }
    module.hot.accept("./TermsConditionsView.vue?vue&type=template&id=d1e68abc&", function () {
      api.rerender('d1e68abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/TermsConditionsView.vue"
export default component.exports